import * as React from 'react';
import styled from 'styled-components';
import StyledLink from '../StyledLink/styledLink';

const SBulletText = styled.div<{ bold: boolean; color: string; icon: string }>(
  ({ theme, bold, color, icon }) => `
width: 100%;
font-family: Poppins;
font-weight: ${bold ? '700' : '400'};
font-size: ${theme.font.size.smallMedium};
line-height: 17px;
text-align: left;
color: ${color ? color : theme.colors.primaryBackground};
display: flex;
margin-bottom: 20px;
margin-left: 20px;
align-items: flex-start;
@media only screen and ${theme.device.max.laptopS} {
  margin-left: 0;
}
${
  icon
    ? ``
    : `
    &:before {
      content: "\u2713";
      font-family: BlinkMacSystemFont;
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      border: 1px solid ${color ? color : theme.colors.primaryBackground};
      border-radius: 50px;
      display: block;
      height: 15px;
      width: 15px;
      margin-right: 10px;
      text-align: center;
      flex-shrink: 0;
      background-size: contain;
    }
  `
}
`
);

const SIcon = styled.img(
  ({ theme }) => `
  width: 40px;
  height: 40px;
  padding: 20px;
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export default (props) => {
  return (
    <SBulletText {...props}>
      {props.icon ? <SIcon src={props.icon} /> : ''}
      <div>
        {props.text} <StyledLink href={props.linkAddress} target={props.isBlankTarget ? '_blank': '_self'} >{props.link}</StyledLink>
      </div>
    </SBulletText>
  );
};
